module.exports = __webpack_public_path__ + "static/laws-0d5a8d49257b4b4b8e9ad65dd9af9c36.png";